export enum DebtTypeEnum {
    UnstructuredDebt = 1,
    StructuredDebt = 2,
}
  